import React, { Component, useState } from "react";
import { Translation } from "react-i18next";
import i18n from "i18next";
import { connect } from "react-redux";
import {
  Button,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  TablePagination,
  Checkbox,
  withStyles,
} from "@material-ui/core";
import {
  clearTrackInput, 
  prsSearch,
} from "../../redux/actions/MlTrackLibraryActions";
import RefreshIcon from "@material-ui/icons/Refresh";
import { FaEraser } from "react-icons/fa";
import { TextInput } from "../../util/input-elements/TextInput";
import clsx from "clsx";
import { styles } from "./MlPrsSearch.css";
// import trackFields from "../../_module/definition/trackFields";
import Columns from "../../modules/ml-licensing/clearance-form/trackInputColumn";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableDataCol from "../../util/TableDataCol";
import TableHeaderCol from "../../util/TableHeaderCol";
import { CFOrgStatus, defaultPopupResults, pagingTotalRelation, resultsPerPage } from "../../redux/Types";
import { deepCopyFunction } from "util/CommonFunc";
import AddIcon from "@material-ui/icons/Add";
import store from "redux/Store";
import CloseIcon from "@material-ui/icons/Close";

class MlPrsSearch extends Component {

    rowsPerPage = defaultPopupResults;
    page = 0;
    startRecord=1;
    totalResults = 0;
    displayFields = [
      "trackTitle",
      "performer",
      "prs",
      "musicOrigin",
      "isrc",
      "iswc",
      "catNo",
      "recordLabel",
      // "publisher",
      // "composer",
      "duration"
    ];

    prsSearchFields = [
      {
        id:'Title', 
        label:'Title', 
        selectorLabel:'Title', 
      },
      {
        id:'ArtistName1', 
        label:'Artist',
        selectorLabel:'Title and Artist',
      },
      // {
      //   id:'ArtistName2', 
      //   label:'ArtistName2'
      // },
      // {
      //   id:'ProdTitle', 
      //   label:'Album Title', 
      // },
      // {
      //   id:'ProdLabel', 
      //   label:'Album label', 
      // },
      {
        id:'IsrcNo', 
        label:'ISRC',
        selectorLabel:'ISRC',
      },
      // {
      //   id:'ProdCatNo', 
      //   label:'Album ID', 
      // },
      {
        id:'Tunecode', 
        label:'PRS Tune Code', 
        selectorLabel:'PRS Tune Code', 
      },
    ];

    constructor(props){
      super();
      this.state = {        
        prsSearch:{
          Title:"", 
          ArtistName1:"", 
          ProdTitle:"", 
          ProdLabel:"", 
          IsrcNo:"", 
          ProdCatNo:"", 
          Tunecode:"", 
        }, 
        selectedPrsTrack: null,
        prsSelectedField:["Title"], 
        prsSearchId : "",
        prsSessionId : "",
      }
      this.openDialog = this.openDialog.bind(this);
      this.closeDialog = this.closeDialog.bind(this);
    }

    componentDidMount(){

           
    }

    setTotalItems() {
      const {
        data: {
          trackInputData: { totalItems },
        },
      } = this.props;
      this.totalResults =
      totalItems !== undefined? totalItems !== this.totalResults? totalItems: this.totalResults: this.totalResults;
    }

    openDialog() {
      this.setState({
        dialogOpen: true,
      });

      const {       
        sourceTitle,
        sourcePerformer
       } = this.props;

      if(sourceTitle)
        this.state.prsSearch.Title = sourceTitle;

      if(sourcePerformer){
        this.state.prsSearch.ArtistName1 = sourcePerformer;
        this.onPrsFieldSelected('ArtistName1')
      } 
      
      if(sourceTitle || sourcePerformer)
        this.searchPRS();      
    }

    closeDialog() {
     
      this.setState({
        dialogOpen: false,
        selectedPrsTrack: null,
      });
    }
    
    onPrsFieldSelected = (field) => {     

      const { prsSelectedField } = this.state;

      let index = prsSelectedField.findIndex(d=>d == field);
      if(index == -1){
        if(field == 'Title' || field == 'ArtistName1'){
          ['Tunecode', 'IsrcNo'].forEach(f=>{
            let i = prsSelectedField.findIndex(d=>d == f);
            if(i != -1){
              prsSelectedField.splice(i, 1);
            }
          })
          prsSelectedField.push(field);
        }
        else{
          prsSelectedField.splice(0, prsSelectedField.length);
          prsSelectedField.push(field);
        }
      }
      else{
        prsSelectedField.splice(index, 1);
      }
      this.setState({
        prsSelectedField:prsSelectedField, 
        // prsSearch:ps
      });
    }
    
    isVisibleField(field){
      // return this.state.prsSelectedField == 'Tunecode'?(field == 'Tunecode'?false:true):
      //   this.state.prsSelectedField == 'IsrcNo'?(field == 'IsrcNo'?false:true):
      //   // this.state.prsSelectedField == 'ProdCatNo'?(field == 'ProdCatNo'?false:true):
      //   // this.state.prsSelectedField == 'ProdLabel'?(['ProdTitle', 'ProdLabel'].indexOf(field) != -1?false:true):
      //   ['Title',].indexOf(this.state.prsSelectedField) != -1?(['Title'].indexOf(field) != -1?false:true):
      //   ['ArtistName1'].indexOf(this.state.prsSelectedField) != -1?(['ArtistName1'].indexOf(field) != -1?false:true):true;
      //   // ['ArtistName1', 'Title', 'ProdTitle'].indexOf(this.state.prsSelectedField) != -1?(['ArtistName1', 'Title', 'ProdTitle'].indexOf(field) != -1?false:true):false;
      return this.state.prsSelectedField.indexOf(field) != -1?true:false;
    }

    searchPRS() {
      const {
        data: { trackInputData },
        prsSearch,
      } = this.props;
      this.setState({
        isError:false
      })
  
      let prsData = {
        // ...this.state.prsSearch, 
        searchId: this.state.prsSearchId,
        startRecord: 1,
        sessionId: this.state.prsSessionId,
        sessionExp: null,
      };
      
  
      if(this.state.prsSelectedField.length>0){
        if(this.state.prsSelectedField.length == 1){
          if(this.state.prsSelectedField[0] == 'ArtistName1'){
            prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1; 
          }
          else{
            prsData[this.state.prsSelectedField[0]] = this.state.prsSearch[this.state.prsSelectedField[0]];
          }
        }
        else if(this.state.prsSelectedField.length == 2){
          prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1; 
          prsData['Title'] = this.state.prsSearch.Title; 
        }
      }
      else{
        if(this.state.prsSearch.Tunecode){
          prsData['Tunecode'] = this.state.prsSearch.Tunecode;
        }
        else if(this.state.prsSearch.IsrcNo){
          prsData['IsrcNo'] = this.state.prsSearch.IsrcNo;
        }
        else if(this.state.prsSearch.ArtistName1.length>0 && this.state.prsSearch.Title){
          prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1; 
          prsData['Title'] = this.state.prsSearch.Title; 
        }
        else if(this.state.prsSearch.Title){
          prsData['Title'] = this.state.prsSearch.Title; 
        }
        else if(this.state.prsSearch.ArtistName1.length>0){
          prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1; 
        }
      }
      
      prsSearch(
        { ...trackInputData.query },
        prsData, 
        (res, err = null) => {
          if(!err){
            this.setState({
              prsSearchId:res.searchId, 
              prsSessionId:res.sessionId
            });
          }
          else{
          }
        }
      );
      this.page = 0;
      this.startRecord =  prsData.startRecord;
    }

    displayingResult(){

      if(this.state.prsSelectedField.length>0){
        if(this.state.prsSelectedField.length == 1){
          if(this.state.prsSelectedField[0] == 'ArtistName1'){
            return `Artist = ${ Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1}`;
          }
          else{
            return `${this.state.prsSelectedField[0]} = ${this.state.prsSearch[this.state.prsSelectedField[0]]}`;
          }
        }
        else if(this.state.prsSelectedField.length == 2){
          return `Title = ${this.state.prsSearch.Title} AND Artist = ${Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1}`;
        }
      }
      else{
        if(this.state.prsSearch.Tunecode){
          return `Tunecode = ${this.state.prsSearch.Tunecode}`;
        }
        else if(this.state.prsSearch.IsrcNo){
          return `IsrcNo = ${this.state.prsSearch.IsrcNo}`;
        }
        else if(this.state.prsSearch.ArtistName1.length>0 && this.state.prsSearch.Title){
          return `Title = ${this.state.prsSearch.Title} AND Artist = ${Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1}`;
        }
        else if(this.state.prsSearch.Title){
          return `Title = ${this.state.prsSearch.Title}`;
        }
        else if(this.state.prsSearch.ArtistName1.length>0){
          return `Artist = ${ Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1}`;
        }
      }
    }

    isExistingCFTrack(trackId) {
      const { cfFormContent } = this.props;
      let index = cfFormContent.editing.clearance.tracks.findIndex(
        (item) => item == trackId
      );
      if (index != -1) return true;
      else return false;
    }
    
    handlePrsValChange = (event) => {
      const { prsSearch } = this.state;
      prsSearch[event.target.name] = event.target.value;
      this.setState({
        prsSearch: prsSearch,
        prsSearchId:""
      });
    };

    handleChangePageSearchPRS = (event, value) =>  {
      const {
        data: {
          trackInputData, 
        },
        prsSearch,
      } = this.props;
      this.setState({
        isError:false
      })
  
      let prsData = {
        // ...this.state.prsSearch, 
        searchId: this.state.prsSearchId,
        startRecord: value == 0? 1 : (value == this.page + 1)? (this.startRecord + 20) : (value == this.page - 1)? (this.startRecord - 20) : 1,
        sessionId: this.state.prsSessionId,
        sessionExp: null,
      };
      if(this.state.prsSearch.Tunecode){
        prsData['Tunecode'] = this.state.prsSearch.Tunecode;
      }
      else if(this.state.prsSearch.IsrcNo){
        prsData['IsrcNo'] = this.state.prsSearch.IsrcNo;
      }
      else if(this.state.prsSearch.ArtistName1.length>0 && this.state.prsSearch.Title){
        prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1; 
        prsData['Title'] = this.state.prsSearch.Title; 
      }
      else if(this.state.prsSearch.Title){
        prsData['Title'] = this.state.prsSearch.Title; 
      }
      else if(this.state.prsSearch.ArtistName1.length>0){
        prsData['ArtistName1'] = Array.isArray(this.state.prsSearch.ArtistName1)?this.state.prsSearch.ArtistName1.join(', '):this.state.prsSearch.ArtistName1; 
      }
  
      prsSearch(
        { ...trackInputData.query },
        prsData, 
        (res, err = null) => {
          if(!err){
            this.setState({
              prsSearchId:res.searchId, 
              prsSessionId:res.sessionId
            });
          }
          else{
          }
        }
      );
      this.page = value;
      this.startRecord =  prsData.startRecord;
    }

    resetData(){
      this.setState({

        prsSearch:{
          Title:"", 
          ArtistName1:"", 
          ProdTitle:"", 
          ProdLabel:"", 
          IsrcNo:"", 
          ProdCatNo:"", 
          Tunecode:"", 
        }, 
        selectedPrsTrack: null,
        prsSelectedField:["Title"], 
        prsSearchId : "",
        prsSessionId : "",
      })
    }

    render() {
      const { 
        classes, 
        data: {
          trackInputData: { items, loading, prsLoading, totalRelation },
        },
        customTrack, mlSearch, 
        cf: {
          posting: { busy },
        },
        withBackBtn, 
        buttonLabel, 
        actionLabel, 
        alwaysActive, 
        importLoading       
       } = this.props;

       const {
        orgRuntime: {
          runtime: {
            _trackFields: trackFields,
        
          }
        }
      } = store.getState(); 

      this.columns = this.displayFields.map((v) => {
        let label =
          !trackFields[v] || trackFields[v]?.sys ? "" : i18n.t(`modules.${v}`);
        return {
          ...(Columns[v] || {}),
          field: v,
          type: Columns[v].type,
          label,
        };
      });
      this.setTotalItems();
      return (
        <Translation>
        {(t, { i18n }) => (
          <>
            <Button
              type="button"
              variant="contained"
              color="primary"
              className={clsx(classes.globalCreateSaveButton, classes.prsButton)}
              aria-label={"Find Tracks from PRS"}
              aria-controls="prsSearch"
              aria-haspopup="true"
              disabled={alwaysActive?false:customTrack?(customTrack.trackTitle.trim() || customTrack.performer.length>0 || customTrack.isrc.trim() || customTrack.prs.trim()?(busy?true:false):true):mlSearch?(mlSearch.text.trim()?(busy?true:false):true):true}
              onClick={()=>{
                this.openDialog();
                const { clearTrackInput, customChanged, setCustomChanged } = this.props;
                
                if(customTrack){
                  let toField = 'Title';
                  let ps = {
                    Title:customTrack.trackTitle, 
                    ArtistName1:customTrack.performer, 
                    IsrcNo:customTrack.isrc, 
                    Tunecode:customTrack.prs, 
                  }
                  if(customTrack.prs){
                    // ps.Tunecode = customTrack.prs;
                    toField = 'Tunecode';
                  }
                  else if(customTrack.isrc){
                    // ps.IsrcNo = customTrack.isrc;
                    toField = 'IsrcNo';
                  }
                  else if(customTrack.trackTitle && customTrack.performer.length == 0){
                    // ps.Title = customTrack.trackTitle;
                    toField = 'Title';
                  }
                  else if(customTrack.trackTitle || customTrack.performer.length>0){
                    // ps.Title = customTrack.trackTitle;
                    // ps.ArtistName1 = customTrack.performer;
                    toField = 'ArtistName1';
                  }
                  this.setState({
                    prsSelectedField:[toField], 
                    prsSearch:ps, 
                    isError:false
                  }, ()=>{
                    if(!this.state.prsSearchId){
                      clearTrackInput();
                    }
                    if(this.state.prsSearch.Title || 
                      this.state.prsSearch.ArtistName1 ||
                      this.state.prsSearch.IsrcNo ||
                      this.state.prsSearch.Tunecode){
                        if(!this.state.prsSearchId || customChanged){
                          this.searchPRS();
                          setCustomChanged();
                        }
                    }
                  });
                }
                else if(mlSearch){
                  let toField = 'Title';
                  let ps = {
                    Title:"", 
                    ArtistName1:"", 
                    IsrcNo:"", 
                    Tunecode:"", 
                  }
                  if(mlSearch.field == 'prs'){
                    ps.Tunecode = mlSearch.text;
                    toField = 'Tunecode';
                  }
                  else if(mlSearch.field == 'isrc'){
                    ps.IsrcNo = mlSearch.text;
                    toField = 'IsrcNo';
                  }
                  else if(mlSearch.field == 'trackTitle'){
                    ps.Title = mlSearch.text;
                    toField = 'Title';
                  }
                  else if(mlSearch.field == 'performer'){
                    ps.ArtistName1 = mlSearch.text;
                    toField = 'ArtistName1';
                  }
                  else{
                    ps.Title = mlSearch.text;
                    toField = 'Title';
                  }
                  this.setState({
                    prsSelectedField:[toField], 
                    prsSearch:ps, 
                    isError:false
                  }, ()=>{
                    if(!this.state.prsSearchId){
                      clearTrackInput();
                    }
                    if(this.state.prsSearch.Title || 
                      this.state.prsSearch.ArtistName1 ||
                      this.state.prsSearch.IsrcNo ||
                      this.state.prsSearch.Tunecode){
                        if(!this.state.prsSearchId){
                          this.searchPRS();
                        }
                    }
                  });
                }
              }
            }
            >
              {buttonLabel} {importLoading && <CircularProgress style={{ marginLeft: "10px" }} size={20} className={classes.preLoader} />}
            </Button>
           <Dialog
            open={this.state.dialogOpen || false}
            id="add-track-dialog"
            aria-labelledby="add-track-dialog"
            class="addTracktoClearance "
           >
            <DialogTitle><AddIcon />
              Add Track - Search in PRS
              <Button
                aria-label="Close"
                className={clsx(
                  classes.closeButton
                )}
                title="Close"
                onClick={() =>{                
                    const { closeAddTrack } = this.props;
                    if(closeAddTrack){
                      closeAddTrack();
                    }
                    else{
                      this.closeDialog();
                    }
                  } 
                }
                >
                <CloseIcon />
              </Button>
            </DialogTitle>
            <DialogContent>
              <>
                <div className={classes.searchPRSWrapper}>
                
                  { this.prsSearchFields.map(d=>{
                    return <div>
                        <Checkbox
                          checked={this.isVisibleField(d.id)}
                          onChange={()=>{
                            this.onPrsFieldSelected(d.id);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <TextInput
                        name={d.id}
                        type="text"
                        classes={""}
                        variant="outlined"
                        label={d.label}
                        handleChange={this.handlePrsValChange}
                        errors={this.state.errors || {}}
                        value={this.state.prsSearch[d.id] || ""}
                        onPressEnterKeySearch={() => {
                          this.searchPRS();
                        }}
                        disabled={!this.isVisibleField(d.id)}
                        inputProps={{
                          "aria-label": d.label,
                        }}
                      />
                    </div>;
                  }) }
                  <Button
                  className={clsx(classes.SearchButton, classes.appbarRefreshButton)} 
                      variant="contained"
                      aria-label={"Search Tracks"}
                      onClick={(e) => {
                        this.searchPRS();
                      }}
                      color="primary"
                      autoFocus
                    > <RefreshIcon style={{ fontSize: 18 }} />  Search</Button>
                    <Button
                      title={"Clear search terms"}
                      type="button"
                      variant="contained"
                      color="primary"
                      aria-label={"Clear search terms"}
                      className={clsx(classes.appbarRefreshButton, classes.resetDataButton)}
                      onClick={() => {
                        const { clearTrackInput, setCustomChanged } = this.props;
                        const { prsSearch } = this.state;
                        prsSearch.Title = ""; 
                        prsSearch.ArtistName1 = ""; 
                        prsSearch.IsrcNo = ""; 
                        prsSearch.Tunecode = ""; 
                        this.setState({
                          prsSearch:prsSearch
                        }, ()=>{
                            if(setCustomChanged){
                              setCustomChanged();
                            }
                            if(clearTrackInput){
                              clearTrackInput();
                            }
                        })
                      }}
                    >
                      <FaEraser style={{ fontSize: 15 }} />
                    </Button>
                </div>
                { this.displayingResult() && (
                  <div className={classes.displayResults}>Displaying results for <span>{this.displayingResult()}</span></div>
                ) }
              </>
              <>
               <div>
                <div className={classes.relativeDiv}>
                  <TableContainer className={classes.tableMaxHeight}>
                    <Table stickyHeader className={""}>
                      <TableHead>
                        <TableRow>
                          {this.columns.map((column) => (
                            <TableHeaderCol
                              columns={this.columns}
                              key={column.field}
                              {...this.props}
                              column={column}
                            />
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {items &&
                          items.length > 0 &&
                          items.map((row) => {
                            return (
                              <>
                                <TableRow
                                  key={row.id}
                                  className={""}
                                  selected={this.state.selectedPrsTrack && row.id == this.state.selectedPrsTrack.id}
                                  onClick={() => {
                                    this.setState({
                                      selectedPrsTrack: row,
                                    });
                                  }}
                                >
                                  {this.columns.map((c, i) => (
                                    <TableDataCol
                                      key={c.field + row.id}
                                      {...this.props}
                                      column={c}
                                      row={row}
                                      rowId={row.id}
                                      selected={this.state.selectedPrsTrack && row.id == this.state.selectedPrsTrack.id}
                                    />
                                  ))}

                                </TableRow>
                              </>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {items && !items.length && !loading && !prsLoading && (
                  
                        <div  className={classes.noData}>
                        {t("tableView.noDataToPreview")}
                    </div>
                    
                  )}
                  {items && !items.length && (loading || prsLoading) && (
                    
                      <CircularProgress
                          size={40}
                          className={classes.progressnew}
                        />
                      
                  )}
                </div>
                <div className={classes.tracksPagination}>
                  <TablePagination
                    labelRowsPerPage={""}
                    labelDisplayedRows={({ from, to, count }) => {
                      return(`${from.toLocaleString()}-${to.toLocaleString()} of ${(count > 0 && totalRelation === pagingTotalRelation.GREATER_THAN) ? `${count.toLocaleString()}+` : count.toLocaleString()}`)}}  
                    rowsPerPageOptions={[20]}
                    component={"div"}
                    count={this.totalResults} //total records count
                    rowsPerPage={20}
                    page={this.page}
                    SelectProps={{
                      inputProps: {
                        "aria-label": "results per page",
                        id: "trackInputPaging",
                        "aria-labelledby": "trackInputPaging",
                      },
                    }}
                    onChangePage={this.handleChangePageSearchPRS}
                    onChangeRowsPerPage={null}
                  />
                </div>
              </div>
              </>
            </DialogContent>
            <DialogActions>
              { withBackBtn && (
                <Button
                  className={clsx(classes.globalCreateSaveButton)}
                  variant="contained"
                  aria-label={"Back"}
                  onClick={(e) => {
                    const { mlSearch, clearTrackInput, onBack } = this.props;
                    // this.page = 0;
                    this.setState({ 
                      prsSelectedField:["Title"], 
                      prsSearch:{
                        Title:"", 
                        ArtistName1:"", 
                        IsrcNo:"", 
                        Tunecode:"", 
                      }
                    }, ()=>{
                      if(mlSearch){
                        this.resetData();
                        clearTrackInput();
                      }
                      this.closeDialog();
                      onBack();
                    });
                    
                  }}
                  color="primary"
                >
                Back
              </Button>
              ) }
              <Button
                className={clsx(classes.globalCreateSaveButton)}
                variant="contained"
                aria-label={"Import Data"}
                disabled={this.state.selectedPrsTrack?false:true}
                onClick={(e) => {
                  const { selectedPrsTrack } = this.state;
                  const { importData, setCustomChanged } = this.props;
                  
                  this.setState({
                    prsSelectedField:["Title"], 
                    prsSearch:{
                      Title:"", 
                      ArtistName1:"", 
                      IsrcNo:"", 
                      Tunecode:"", 
                    }, 
                  }, ()=>{
                    importData(selectedPrsTrack);
                    if(setCustomChanged){
                      setCustomChanged();
                    }
                    this.closeDialog();
                  })
                }}
                color="primary"
                autoFocus
              >{actionLabel}
              </Button>
              {/* <Button
                className={classes.globalGrayButton}
                aria-label={"Cancel and Close Popup"}
                onClick={(e) => {
                  const { closeAddTrack } = this.props;
                  if(closeAddTrack){
                    closeAddTrack();
                  }
                  else{
                    this.closeDialog();
                  }
                }}
                autoFocus
                >
                Cancel
              </Button> */}
            </DialogActions>
           </Dialog>
            
          </>
        )}
        </Translation>
      )
    }
}

const mapStateToProps = (state) => ({
  data: state.mltracklibrary,
  cfFormContent: state.mllicformcontent,
  cf: state.mllicform,
});

export default connect(mapStateToProps, {
  prsSearch, 
  clearTrackInput,
})(withStyles(styles)(MlPrsSearch));
